import deleteModalTemplate from './item.delete.modal.html';
import selectModalTemplate from './item.select.modal.html';
import manageModalTemplate from '../../catalog/catalog.manage.modal.html';

class MenuItemController {
  /* @ngInject */
  constructor($rootScope, $timeout, $translate, $filter, ModalFactory, MenuActions, MenuStore, StoreStates, FoundationApi, NewTokenService) {
    const that = this;

    that.loading = {
      menu: false
    };
    const closeModal = (modal) => {
      modal.deactivate();
      $timeout(modal.destroy, 1000);
    };

    that.catalogDialog = {
      id: 'catalog_dialog',
      title: $filter('translate')(`menu.main.modal.errortitle`),
      text: $translate.instant('menu.main.modal.modalbody.deletemenu', { name: that.menu.name }),
      isConfirm: false,
      closeFunc: undefined,
      confirmFunc: {}
    };

    const loadMenu = () => {
      const menuId = that.menu.id;
      if (menuId) {
        if (MenuStore.getMenuStoreState() === StoreStates.STORE_VALID) {
          that.menu = MenuStore.getMenu(menuId);
          if (that.menu !== undefined) {
            that.menu.state = that.menu.active;
          }
          that.loading.menu = false;
        } else if (MenuStore.getMenuStoreState() === StoreStates.STORE_PENDING_UPDATE) {
          that.loading.menu = true;
        } else {
          that.loading.menu = true;
          MenuActions.getMenus();
        }
      }
    };

    that.deleteMenu = () => {
      if ((that.menu.enabled) && that.menu.active) {
        FoundationApi.publish('catalog_dialog', 'open');
      } else {
        const modal = new ModalFactory({
          overlay: true,
          overlayClose: false,
          template: deleteModalTemplate,
          contentScope: {
            body: $translate.instant('menu.main.delete.body', {
              name: that.menu.name
            }),
            cancel: () => closeModal(modal),
            delete: () => {
              that.loading.menu = true;
              MenuActions.deleteMenu(that.menu.id);
              closeModal(modal);
            }
          }
        });
        if (MenuStore.getMenus().length === 1 && that.menu.enabled) {
          FoundationApi.publish('items_dialog', 'open');
        } else {
          modal.activate();
        }
      }
    };

    that.selectProducts = () => {
      const modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        class: 'large',
        template: selectModalTemplate,
        contentScope: {
          products: that.menu.products,
          loading: that.loading,
          cancel: () => closeModal(modal),
          save: () => {
            that.loading.menu = true;
            MenuActions.setMenuProducts(that.menu.id, that.menu.products);
            const deregSaveMenuProductsListener = $rootScope.$on('SAVEMENU', () => {
              deregSaveMenuProductsListener();
              closeModal(modal);
            });
          }
        }
      });

      modal.activate();
    };

    /*that.setMenuStatus = (id) => {
      if ((that.settings && that.settings.menu.enabled) && that.activeMenu && that.activeMenu.id === id) {
        FoundationApi.publish('items_dialog', 'open');
        that.menu.state = !that.menu.state;
      } else {
        if (that.activeMenu && that.activeMenu.id !== id) {
          const modal = new ModalFactory({
            overlay: true,
            overlayClose: false,
            template: manageModalTemplate,
            contentScope: {
              body: $translate.instant('menu.main.manage.body', {
                name: that.menu.name
              }),
              cancel: () => {
                that.menu.state = !that.menu.state;
                closeModal(modal);
              },
              manage: () => {
                that.loading.menu = true;
                if (that.menu.state === true) {
                  that.enableMenu();
                  MenuActions.disableMenu(that.activeMenu.id);
                } else {
                  that.disableMenu();
                }
                closeModal(modal);
              }
            }
          });
          modal.activate();
        } else {
          if (that.menu.state === true) {
            that.enableMenu();
          } else {
            that.disableMenu();
          }
        }
      }
    };*/

    that.editMenu = () => {
      const modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        class: 'large',
        template: `<edit-menu mode="edit" on-cancel="cancel()" menu="menu"></edit-menu>`,
        contentScope: {
          menu: that.menu,
          cancel: () => {
            that.loading.menu = false;
            closeModal(modal);
          }
        }
      });

      modal.activate();
    };

    that.enableMenu = () => {
      MenuActions.enableMenu(that.menu.id);
    };

    that.disableMenu = () => {
      MenuActions.disableMenu(that.menu.id);
    };

    const deregSaveMenuListener = $rootScope.$on('SAVEMENU', () => {
      that.loading.menu = false;
    });

    const deregSaveMenuFailListener = $rootScope.$on('SAVEMENU_FAIL', () => {
      loadMenu();
    });

    const deregMenuUpdateListener = $rootScope.$on('MENU_UPDATE', loadMenu);

    const deregMenuUpdateFailListener = $rootScope.$on('MENU_FAIL', () => {
      that.loading.menu = false;
    });

    that.$onDestroy = () => {
      deregSaveMenuListener();
      deregSaveMenuFailListener();
      deregMenuUpdateListener();
      deregMenuUpdateFailListener();
    };
  }
}

export default MenuItemController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/main/item/item.controller.js
 **/